import { render, staticRenderFns } from "./px-callout.vue?vue&type=template&id=e32ef852&scoped=true&"
import script from "./px-callout.vue?vue&type=script&lang=ts&"
export * from "./px-callout.vue?vue&type=script&lang=ts&"
import style0 from "./px-callout.vue?vue&type=style&index=0&id=e32ef852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32ef852",
  null
  
)

export default component.exports